module.exports = __webpack_public_path__ + "static/img/banner.d1e5676.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banner.png
// module id = qZt/
// module chunks = 1